import textFit from 'textfit';
import _throttle from 'lodash.throttle';

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const headlines = document.querySelectorAll(
      '.c-intro__headline h1,.c-intro__headline h2, .c-intro__headline h3, .c-intro__headline h4, .c-intro__headline h5',
    );

    const textSettings = {
      multiLine: true, // if true, textFit will not set white-space: no-wrap
      detectMultiLine: true, // disable to turn off automatic multi-line sensing
      minFontSize: 6,
      maxFontSize: 200,
      reProcess: true, // if true, textFit will re-process already-fit nodes. Set to 'false' for better performance
      widthOnly: false, // if true, textFit will fit text to element width, regardless of text height
      alignVertWithFlexbox: false, // if true, textFit will use flexbox for vertical alignment
    };

    if (headlines) {
      headlines.forEach(headline => {
        const sticky = headline.querySelectorAll('.c-text--sticky');

        if (sticky.length > 0) {
          if (sticky.length <= 1) {
            textFit(sticky, textSettings);
            // Readjust on window resize
            window.addEventListener(
              'resize',
              _throttle(() => textFit(sticky, textSettings), 500),
            );
          }
        } else {
          textFit(headline, textSettings);
          window.addEventListener(
            'resize',
            _throttle(() => textFit(headline, textSettings), 500),
          );
        }
      });
    }
  }, 1500);
});



// WEBPACK FOOTER //
// ./src/scripts/modules/responsiveText.js